module.exports = __webpack_public_path__ + "media/images/gps-aed9cc04dec4f708bb4c64f8ab87d467.png";